import React from 'react';

type Source = JSX.IntrinsicElements['source'] & {
    src: string;
    maxWidth: number;
};
export type PictureProps = JSX.IntrinsicElements['img'] & {
    src: string;
    alt: string;
    sources: Source[];
    fetchPriority?: string;
};

export function Picture({ sources, ...props }: PictureProps) {
    return (
        <picture>
            {sources.map(({ src, maxWidth, ...attributes }) => (
                <source
                    key={src}
                    srcSet={src}
                    media={`(max-width: ${maxWidth}px)`}
                    {...attributes}
                />
            ))}

            <img {...props} alt={props.alt} />
        </picture>
    );
}
